import { getServiceUrl } from '../api.config';
import { ApiClientOptions } from '../types/api';
import ApiClient from '../utils/ApiClient';

export default class ProductReferenceClaimApi extends ApiClient {
  public constructor(options?: ApiClientOptions) {
    super(getServiceUrl('core'), options);
  }

  public refuse(data: any) {
    const query = '/core/v3/productreferences/refuse';
    return this.post(query, data);
  }
}
